export function* seededRandom(initialSeed: number): Generator<number, never, unknown> {
    let state0: number
    let state1: number

    // Initialize with SplitMix32 for better seed distribution
    let s = initialSeed >>> 0
    s = Math.imul(s ^ (s >>> 16), 0x85ebca6b)
    s = Math.imul(s ^ (s >>> 13), 0xc2b2ae35)
    state0 = (s ^ (s >>> 16)) >>> 0
    
    s = Math.imul(s ^ (s >>> 16), 0x85ebca6b)
    s = Math.imul(s ^ (s >>> 13), 0xc2b2ae35)
    state1 = (s ^ (s >>> 16)) >>> 0

    while (true) {
        let s1 = state0
        const s0 = state1
        state0 = s0
        s1 ^= s1 << 23
        s1 ^= s1 >>> 17
        s1 ^= s0
        s1 ^= s0 >>> 26
        state1 = s1 >>> 0
        yield (state0 + state1) >>> 0
    }
}

export function* seededRandomFloat(seed: number): Generator<number, never, unknown> {
    const rng = seededRandom(seed)
    while (true) {
        yield rng.next().value / 0x100000000
    }
}

export function* seededRandomInt(seed: number, min: number, max: number): Generator<number, never, unknown> {
    const floatRng = seededRandomFloat(seed)
    while (true) {
        yield Math.floor(floatRng.next().value * (max - min + 1)) + min
    }
}

export function hashCode(str: string): number {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i)
    hash = hash & hash
  }
  return Math.abs(hash)
}
